import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';

interface Props {
  isDirty?: boolean;
  loading?: boolean;
  onCancel: () => void;
}

function ReminderFormActions(props: Props) {
  const { isDirty, loading, onCancel } = props;
  const { t } = useTranslation();
  const actions = [
    <Button
      buttonText={t('cancel')}
      buttonType={ButtonTypes.secondaryOutlined}
      data-test-id="reminder__cancel-button"
      disabled={!isDirty || loading}
      fullWidth
      leftIcon="close"
      onClick={onCancel}
    />,
    <Button
      buttonText={t('save-changes')}
      buttonType={ButtonTypes.primaryFilled}
      data-test-id="reminder__save-button"
      disabled={!isDirty}
      fullWidth
      isLoading={loading}
      leftIcon="check"
      type="submit"
    />,
  ];
  return <ActionsRow actions={actions} />;
}

export default ReminderFormActions;
